/* eslint-disable react/prop-types */
import React,
{
  Component,
  Fragment,
} from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import HorizontallyNavigableContent from 'kentico-blocks/HorizontallyNavigableContent';
import ds, { media } from 'designsystem';
import root from 'window-or-global';
import { withRouter } from 'react-router-dom';
import TagAGetTheApp from 'blocks/Navigation/Buttons/TagAGetTheApp';
import { Bind } from 'lodash-decorators';
import { withLastLocation } from 'react-router-last-location';
import ANCHOR from 'common/consts/anchor';
import SplashScreen from 'blocks/SplashScreen';
import Logo from 'blocks/Navigation/Logo';
import CloseIcon from 'blocks/CloseIcon';
import InjectMetaTags from 'blocks/InjectMetaTags';

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${media.tablet`
    margin: ${ds.get('metrics.m')} ${ds.get('metrics.l')};
  `}
`;

const StyledCloseIcon = styled(CloseIcon)`
  position: relative;
  display: inline-block;
  top: 7px;
  right: 0;
  width: ${ds.get('metrics.xs')};
`;

@inject('coreStore', 'appStore')
@observer
class ContactFormPage extends Component {
  componentDidMount() {
    root.scrollTo(0, 0);
  }

  @Bind
  goBack() {
    const {
      history,
      lastLocation,
      appStore: {
        currentLanguage,
      },
    } = this.props;

    if (lastLocation) {
      history.goBack();
    } else {
      // if user came from web (outside), on contact form close go to the main page:
      history.push(ANCHOR.HOME[currentLanguage]);
    }
  }

  render() {
    const {
      coreStore: {
        initialCoreDataFetchDone,
        translations,
        blogContactComponent,
        content: { contactSEO }
      },
    } = this.props;

    if (!initialCoreDataFetchDone) {
      return <SplashScreen />;
    }

    return (
      <Fragment>
        <InjectMetaTags {...contactSEO} />
        <NavContainer>
          <Logo big />
          <TagAGetTheApp
            onClick={this.goBack}
          >
            {translations.NAVIGATION_GET_THE_APP}
            <StyledCloseIcon
              color={ds.brand('background')}
              height="18px"
              width="1px"
            />
          </TagAGetTheApp>
        </NavContainer>
        <HorizontallyNavigableContent
          data={blogContactComponent}
        />
      </Fragment>
    );
  }
}
export default withRouter(withLastLocation(ContactFormPage));



// WEBPACK FOOTER //
// ./src/pages/ContactForm/index.jsx